import L from "leaflet";

Map.addTile = function (map) {
  //init tile layer with OpenStreeMap attribution
  let tileLayer = L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
    maxZoom: 19,
    attribution:
      '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>, &copy; <a href="https://carto.com/attribution">CARTO</a>'
  });

  tileLayer.addTo(map);
};

Map.addLocateControl = function (map) {
  L.control.locate({
    position: "topright",
    showCompass: "true",
    strings: {
      title: "Pokaż mi gdzie jestem."
    }
  }).addTo(map);
};

Map.addZoomControl = function (map) {
  return new L.Control.Zoom({
    position: "topright"
  }).addTo(map);
};

Map.initMap = function (lat, lon, zoom) {
  return L.map("map", { zoomControl: false }).setView(
    [lat, lon],
    zoom
  );
};

Map.getConstraints = function (map) {
  var constraints = "";
  var bounds = map.getBounds();
  if (bounds) {
    constraints =
      "POLYGON (( " +
      bounds.getSouthWest().lng +
      " " +
      bounds.getSouthWest().lat +
      ", " +
      bounds.getSouthWest().lng +
      " " +
      bounds.getNorthEast().lat +
      "," +
      bounds.getNorthEast().lng +
      " " +
      bounds.getNorthEast().lat +
      "," +
      bounds.getNorthEast().lng +
      " " +
      bounds.getSouthWest().lat +
      "," +
      bounds.getSouthWest().lng +
      " " +
      bounds.getSouthWest().lat +
      "))";
  }

  return constraints;
};

Map.showPopup = function (map, displaySize, popupRef, e, markerColorFunction) {
  if (displaySize == "xs") {
    let markerColor = markerColorFunction();

    //pan to marker x,y (in pixels)
    let mapSize = map.getSize();
    let destX = -(mapSize.x / 2 - e.originalEvent.clientX) - 4;
    let destY = -(mapSize.y / 2 - e.originalEvent.clientY) + 50;
    map.panBy(new L.Point(destX, destY));

    let popupPanel = document.getElementById("popupPanel");
    while (popupPanel.firstChild) {
      popupPanel.removeChild(popupPanel.firstChild);
    }

    let pointer = document.createElement("div");
    pointer.classList.add("popup-panel-pointer");
    pointer.style.borderBottom = "20px solid " + markerColor;
    popupPanel.append(pointer);

    popupPanel.append(popupRef.$mount().$el);
    popupPanel.style.display = "block";
    popupPanel.style.borderTop = "2px solid " + markerColor;

    let popupPanelCloseButton = document.getElementById("popupPanelCloseButton");
    popupPanel.addEventListener("click", function (el) {
      popupPanel.style.display = "none";
    });

  } else {
    let autoPan = true;
    if (e.containerPoint.y < 350) {
      let destY = - (350 - e.containerPoint.y) - 200;
      map.panBy(new L.Point(0, destY));
      autoPan = false;
    }

    var popup = L.popup({ autoPan, minWidth: 250 })
      .setLatLng(e.latlng)
      .setContent(popupRef.$mount().$el)
      .openOn(map);
  }
};



